import {
  forge,
  EncodeJSON,
  Retry,
  Timeout,
  correlationIdMiddleware,
  Client,
} from '@modifi/api-clients'
import {clientConfig} from '@modifi/client-config'

const resources = {
  Countries: {
    all: {path: '/api/v1/countries', method: 'get'},
  },
  SignUp: {
    submit: {path: '/api/v1/signup', method: 'post'},
  },
  Routing: {
    routes: {path: '/api/v1/routing/routes', method: 'get'},
    navigation: {path: '/api/v1/routing/navigation', method: 'get'},
  },
}

export const serviceClient = (): Client<typeof resources> => {
  const BLOG_URL = clientConfig.get('BLOG_URL', '')
  if (BLOG_URL) {
    resources.Routing.routes.path = `${BLOG_URL}/api/v1/routing/routes`
    resources.Routing.navigation.path = `${BLOG_URL}/api/v1/routing/navigation`
  }

  const client = forge({
    middlewares: [
      correlationIdMiddleware,
      Retry({
        retries: 2,
      }),
      EncodeJSON,
      Timeout(60 * 1000),
    ],
    host: clientConfig.get('hostname', '') as string,
    resources,
  })
  if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    // @ts-ignore
    window.serviceClient = client
  }

  return client
}

export const serviceClientFactory = serviceClient
